









import Vue from 'vue'
import Component from 'vue-class-component'
import { State } from 'vuex-class'

import SettingsHelperComponents2Header from './settings-helper-components-2-header.vue'
import SettingsHelperComponents3ResourceList from './settings-helper-components-3-resource-list.vue'

@Component({
  components: {
    SettingsHelperComponents2Header,
    SettingsHelperComponents3ResourceList
  }
})
class SettingsHelperComponents1MainPage extends Vue {
  @State('isMobileDevice') isMobileDevice?: boolean
}
export default SettingsHelperComponents1MainPage
